export default __webpack_public_path__ + "static/media/Kallisto-Bold.8cf53253.otf";